module.exports = __webpack_public_path__ + "img/16_124.25a74360.png";